export default __webpack_public_path__ + "static/media/weight.8141a23b.gif";